import { AxiosRequestConfig } from "axios";

/* Configs */
import { apiTimeOut } from './App.config';

export const ApiConfig: AxiosRequestConfig = {
  timeout: apiTimeOut,
  headers: {

    "content-type": "application/json;charset=utf-8",
    accept: "application/json"
  },
};